import { Component } from '@angular/core';

@Component({
  selector: 'app-public-auth',
  template: '<router-outlet></router-outlet>',
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        min-height: 100%;
      }
    `],
})
export class PublicAuthComponent {}
